import { RoutineColors } from "@/utilities/routineColors";
import type { Routine } from "instantdb/types";

export const ENERGY_ROUTINES: Partial<Routine>[] = [
  {
    id: "morning-energy-ritual",
    title: "Morning Energy Ritual",
    symbol: "🌞",
    description: "Start your day with habits that maximize natural energy",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[0].value,
    steps: [
      {
        id: "hydration-first",
        title: "Hydration first",
        description: "Drink a full glass of water upon waking to rehydrate",
      },
      {
        id: "energizing-movement",
        title: "Energizing movement",
        description: "Complete 5 minutes of light exercise to activate your body",
      },
      {
        id: "nutritious-breakfast",
        title: "Nutritious breakfast",
        description: "Eat a balanced meal with protein and complex carbohydrates",
      },
    ],
  },
  {
    id: "afternoon-energy-reset",
    title: "Afternoon Energy Reset",
    symbol: "🌞",
    description: "Combat the midday slump with revitalizing practices",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[1].value,
    steps: [
      {
        id: "quick-walk-break",
        title: "Quick walk break",
        description: "Step outside for 5-10 minutes of fresh air and movement",
      },
      {
        id: "breathing-exercise",
        title: "Breathing exercise",
        description: "Practice 10 deep breaths to increase oxygen and alertness",
      },
      {
        id: "healthy-snack",
        title: "Healthy snack",
        description: "Eat something with protein and fiber to stabilize energy",
      },
    ],
  },
  {
    id: "weekly-energy-planning",
    title: "Weekly Energy Planning",
    symbol: "🌞",
    description: "Proactively manage your energy throughout the week",
    dailyRoutine: false,
    selectedDays: [{ day: "sunday", datetime: "18:00:00.000Z" }],
    color: RoutineColors[2].value,
    steps: [
      {
        id: "energy-audit",
        title: "Energy audit",
        description: "Review when your energy peaks and dips during typical days",
      },
      {
        id: "task-alignment",
        title: "Task alignment",
        description: "Schedule demanding tasks during your peak energy periods",
      },
      {
        id: "rest-scheduling",
        title: "Rest scheduling",
        description: "Plan for adequate recovery and downtime between energy demands",
      },
    ],
  },
];
